import { isCirclekDomain } from '@applyonline/shared'
import { memo } from 'react'
import { B2C_MERCHANT_IDS, Constants } from '../../../types'
import { useMerchantLogo, useMerchantLogoLinkDestination } from '../hooks'

interface LogoProps {
  language: string
}

const Logo = ({ language }: LogoProps) => {
  const { logoUrl, merchantId } = useMerchantLogo()
  const destinationLink = useMerchantLogoLinkDestination()
  const ifinanceOnly = isCirclekDomain() || merchantId === B2C_MERCHANT_IDS.circlek

  if (ifinanceOnly) {
    return (
      <figure className="logo">
        <div className="left">
          <a
            href={Constants.Host.Ifinance}
            target="_blank"
            className="btn-simple"
            rel="noreferrer"
            onClick={(e) => {
              e.preventDefault()
              window.open(Constants.Host.Ifinance, '_blank', 'noopener,noreferrer')
            }}
          >
            <img
              id="logo-img"
              className="wide"
              src="https://icebergstatic.blob.core.windows.net/ifinance-merchant-logos/20500.png"
              alt="iFinance Logo"
            />
          </a>
        </div>
      </figure>
    )
  }

  return (
    <figure className="logo">
      <div className="left">
        <a
          href={destinationLink}
          target="_blank"
          className="btn-simple"
          rel="noreferrer"
          onClick={(e) => {
            if (destinationLink) {
              e.preventDefault()
              window.open(destinationLink, '_blank', 'noopener,noreferrer')
            }
          }}
        >
          <img style={{ maxHeight: '70px', maxWidth: '16.4rem' }} id="logo" className="wide" src={logoUrl} alt="Logo" />
        </a>
        <img
          style={{ maxWidth: '20rem' }}
          src={`/images/in_partnership_${language}.svg`}
          alt="in partnership iFinance"
        />
      </div>
    </figure>
  )
}

export default memo(Logo)
